import http from '@root/utils/axios/admin';

let state = {
    DiscussionsList: [],
    GetMainDiscussionsList: [],
    MyCommentsList: [],
    MyDiscussionsLikesList: [],
    Discussion: {
        data: {},
        error: {}
    },
}

let actions = {

    CreateComment({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/subscriber/discussions/comment', data).then((response) => {
                commit('setDiscussion', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setDiscussionError', error.response.data);
                }
                reject(error);
            })
        });
    },
    UpdateComment({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/subscriber/discussions/comment/' + data.id, data).then((response) => {
                commit('setDiscussion', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setDiscussionError', error.response.data);
                }
                reject(error);
            })
        });
    },
    deleteComment({ commit }, id) {
        return http.delete('/subscriber/discussions/comment/' + id);
    },
    fetchDiscussionsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/subscriber/discussions', { params: filter }).then((response) => {
                commit('setDiscussions', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchGetMainDiscussionsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/subscriber/get-discussions', { params: filter }).then((response) => {
                commit('setGetMainDiscussionsList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteDiscussion({ commit }, id) {
        return http.delete('/subscriber/discussions/' + id);
    },

    fetchDiscussion({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('/subscriber/discussions/' + id).then((response) => {
                commit('setDiscussion', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateDiscussion({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/subscriber/discussions', data).then((response) => {
                commit('setDiscussion', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    if (!error.response.data.code) {
                        commit('setDiscussionError', error.response.data);
                    }
                }
                reject(error.response);
            })
        });

    },

    updateDiscussion({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/subscriber/discussions/' + data.get('id'), data).then((response) => {
                commit('setDiscussion', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    if (!error.response.data.code) {
                        commit('setDiscussionError', error.response.data);
                    }
                }
                reject(error.response);
            })
        });
    },

    myCommentsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/subscriber/my/comments', { params: filter }).then((response) => {
                commit('setMyComments', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    myLikesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/subscriber/my/discussions/likes', { params: filter }).then((response) => {
                commit('setMyDiscussionsLikes', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },


}


let mutations = {
    setDiscussions(state, data) {
        state.DiscussionsList = data;
    },
    setGetMainDiscussionsList(state, data) {
        state.GetMainDiscussionsList = data;
    },
    setMyComments(state, data) {
        state.MyCommentsList = data;
    },
    setMyDiscussionsLikes(state, data) {
        state.MyDiscussionsLikesList = data;
    },
    setDiscussion(state, data) {
        state.Discussion.data = data;
    },
    setDiscussionError(state, error) {

        state.Discussion.error = error.errors;
    },
    cleanDiscussionError(state, error) {
        state.Discussion.error = {};
    },
    setDiscussionLike(state, id) {
        state.Discussion.data.is_liked = true;
        state.Discussion.data.likes_count = state.Discussion.data.likes_count + 1;
    },
    setDiscussionUnLike(state, id) {
        state.Discussion.data.is_liked = false;
        state.Discussion.data.likes_count = state.Discussion.data.likes_count - 1;
    },
    setDiscussionReport(state, id) {
        state.Discussion.data.is_reported = true;
    },
    setDiscussionCommentReport(state, id) {
        let comment = state.Discussion.data.comments.find(comment => comment.id === id);
        comment.is_reported = true;
    },

}

export default {
    state,
    actions,
    mutations
}